export const APIURL = "tes3t";
export const MAX_AUDIENCES_UNREGISTERED = 4;
